{
  "title": "Silence",
  "source": "Player's Handbook",
  "levelAndSchool": "2nd-level illusion (ritual)",
  "level": 2,
  "castingTime": "1 action",
  "range": "120 feet",
  "components": "V, S",
  "duration": "Concentration, up to 10 minutes",
  "description": [
    "For the duration, no sound can be created within or pass through a 20-foot-radius sphere centered on a point you choose within range. Any creature or object entirely inside the sphere is immune to thunder damage, and creatures are deafened while entirely inside it. Casting a spell that includes a verbal component is impossible there."
  ],
  "spellLists": ["bard", "cleric", "ranger"]
}
